import React, { useEffect } from "react";
import classes from "./checkout-form.module.scss";
import { validateBillingAddress } from "../../../utils/validators";

function BillingAddressDetails(props) {
  useEffect(() => {
    if (props.profile && !Array.isArray(props.profile) && props.profile.email)
      props.setBillingDetails({
        address_country: props.profile.country || "India",
        address_zipcode: props.profile.pincode || "",
        address_state: props.profile.state || "",
        address_city: props.profile.city || "",
        address_address: props.profile.address || "",
      });
  }, [props.profile]);

  useEffect(() => {
    if (props.VOData.order)
      if (props.VOData.order.billing_address)
        props.setBillingDetails({
          address_country:
            props.VOData.order.billing_address.virtual_order_address_country,
          address_zipcode:
            props.VOData.order.billing_address.virtual_order_address_zipcode,
          address_state:
            props.VOData.order.billing_address.virtual_order_address_state,
          address_city:
            props.VOData.order.billing_address.virtual_order_address_city,
          address_address:
            props.VOData.order.billing_address.virtual_order_address_address,
        });
  }, [props.VOData]);

  const clearBillingError = (field, value) => {
    if (
      !props.validationTrace.billing_address[field] ||
      !props.setValidationTrace
    )
      return;
    const errors = validateBillingAddress({
      ...props.billingDetails,
      [field]: value,
    });
    props.setValidationTrace((prev) => ({
      ...prev,
      billing_address: { ...prev.billing_address, [field]: errors[field] || false },
    }));
  };

  const differentBillingAddressRequsted = () => {
    props.setSameAddress(!props.sameAddress);
    props.updateVO();
  };

  const showBillingForm = () => {
    if (!props.VOData.order) {
      return (
        <div className={classes.formGrid} style={{ marginTop: 16 }}>
          <div className={classes.fullWidth}>
            <div className={classes.skeletonInput} />
          </div>
          <div>
            <div className={classes.skeletonInput} />
          </div>
          <div>
            <div className={classes.skeletonInput} />
          </div>
          <div>
            <div className={classes.skeletonInput} />
          </div>
          <div>
            <div className={classes.skeletonInput} />
          </div>
        </div>
      );
    }

    return (
      <div className={classes.formGrid} style={{ marginTop: 16 }}>
        <div className={classes.fullWidth}>
          <input
            type="text"
            className={classes.formInput}
            placeholder="Address*"
            value={props.billingDetails.address_address}
            onChange={(e) => {
              props.setBillingDetails({
                ...props.billingDetails,
                address_address: e.target.value,
              });
              clearBillingError("address_address", e.target.value);
            }}
          />
          <div
            className={`${classes.errorText} ${
              props.validationTrace.billing_address.address_address
                ? classes.errorVisible
                : classes.errorHidden
            }`}
          >
            {typeof props.validationTrace.billing_address.address_address ===
            "string"
              ? props.validationTrace.billing_address.address_address
              : "Please specify a billing address."}
          </div>
        </div>
        <div className={classes.form_group}>
          <input
            type="text"
            className={classes.formInput}
            placeholder="Pin Code*"
            value={props.billingDetails.address_zipcode}
            onChange={(e) => {
              props.setBillingDetails({
                ...props.billingDetails,
                address_zipcode: e.target.value,
              });
              clearBillingError("address_zipcode", e.target.value);
            }}
          />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.billing_address.address_zipcode
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.billing_address.address_zipcode ===
          "string"
            ? props.validationTrace.billing_address.address_zipcode
            : "Please specify a valid pin code."}
        </div>
        </div>
        <div className={classes.form_group}>
          <input
            type="text"
            className={classes.formInput}
            placeholder="City*"
            value={props.billingDetails.address_city}
            onChange={(e) => {
              props.setBillingDetails({
                ...props.billingDetails,
                address_city: e.target.value,
              });
              clearBillingError("address_city", e.target.value);
            }}
          />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.billing_address.address_city
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.billing_address.address_city === "string"
            ? props.validationTrace.billing_address.address_city
            : "Please specify a valid city."}
        </div>
        </div>
        <div className={classes.form_group}>
          <input
            type="text"
            className={classes.formInput}
            placeholder="State*"
            value={props.billingDetails.address_state}
            onChange={(e) => {
              props.setBillingDetails({
                ...props.billingDetails,
                address_state: e.target.value,
              });
              clearBillingError("address_state", e.target.value);
            }}
          />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.billing_address.address_state
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.billing_address.address_state === "string"
            ? props.validationTrace.billing_address.address_state
            : "Please specify a valid state."}
        </div>
        </div>
        <div className={classes.form_group}>
          <input
            type="text"
            className={classes.formInput}
            placeholder="Country*"
            value={props.billingDetails.address_country}
            onChange={(e) => {
              props.setBillingDetails({
                ...props.billingDetails,
                address_country: e.target.value,
              });
              clearBillingError("address_country", e.target.value);
            }}
          />
        <div
          className={`${classes.errorText} ${
            props.validationTrace.billing_address.address_country
              ? classes.errorVisible
              : classes.errorHidden
          }`}
        >
          {typeof props.validationTrace.billing_address.address_country ===
          "string"
            ? props.validationTrace.billing_address.address_country
            : "Please specify a valid country."}
        </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <label className={classes.checkboxRow} htmlFor="same_shipping_address">
        <input
          type="checkbox"
          className={classes.checkbox}
          name="same_shipping_address"
          id="same_shipping_address"
          checked={props.sameAddress}
          onChange={differentBillingAddressRequsted}
        />
        Use this address as my billing address
      </label>
      {!props.sameAddress && showBillingForm()}
    </>
  );
}

export default BillingAddressDetails;
